import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../config";

// Define a service using a base URL and expected endpoints
export const productApi = createApi({
  reducerPath: "productApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.base_url,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      headers.set("Access-Control-Allow-Origin", "*");
      headers.set("Authorization", "Bearer " + token);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    viewProducts: builder.query({
      query: (cursor) => cursor,
      // Only have one cache entry because the arg always maps to one string
      serializeQueryArgs: ({ queryArgs, endpointDefinition, endpointName }) => {
        return endpointName;
      },
      // Always merge incoming data to the cache entry
      merge: (currentCache, newItems) => {
        currentCache.push(...newItems.data);
      },
      // Refetch when the page arg changes
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg;
      },
    }),
    addProduct: builder.mutation({
      query: (userData) => {
        // console.log("addProduct :: userData ::", userData);
        let formData = new FormData();
        formData.append("post_name", userData.post_name ? userData.post_name : "");
        formData.append("category_id", userData.category_id ? userData.category_id : "");
        formData.append("address", userData.address ? userData.address : "");
        formData.append("city", userData.city ? userData.city : "");
        formData.append("state", userData.state ? userData.state : "");
        formData.append("country", userData.country ? userData.country : "");
        formData.append("zipcode", userData.zipcode ? userData.zipcode : "");
        formData.append("updates", userData.updates ? userData.updates : "");
        formData.append("description", userData.description ? userData.description : "");
        formData.append("post_award", userData.post_award ? userData.post_award : []);
        formData.append("post_tag", userData.post_tag ? userData.post_tag : []);
        if (userData.media_name && userData.media_name.length > 0) {
          for (let i = 0; i < userData.media_name.length; i++) {
            formData.append("media_name[]", userData.media_name[i]);
          }
        }
        formData.append("vendor_website", userData.vendor_website ? userData.vendor_website : "");
        formData.append("vendor_contact", userData.vendor_contact ? userData.vendor_contact : "");
        formData.append("call_to_action", userData.call_to_action ? userData.call_to_action : 1);
        formData.append("action_list", userData.post_call_to_action ? userData.post_call_to_action : []);
        // formData.append(
        //   "button_name",
        //   userData.button_name ? userData.button_name : ""
        // );
        // formData.append("website", userData.website ? userData.website : "");
        console.log("formData ::", formData);
        localStorage.setItem("dat", JSON.stringify(formData));
        return {
          url: "/store-post",
          method: "post",
          body: formData,
        };
      },
    }),
    viewProduct: builder.query({
      query: (productId) => "/view-post?slug=" + productId,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useViewProductsQuery, useAddProductMutation, useViewProductQuery } = productApi;
